import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from '../components/Button';
import { ShieldAlert, FileText, AlertTriangle, Eye } from 'lucide-react';
export function Hero() {
  const [counters, setCounters] = useState({
    risks: 0,
    docs: 0,
    contradictions: 0,
    hidden: 0
  });
  useEffect(() => {
    const interval = setInterval(() => {
      setCounters(prev => ({
        risks: Math.min(prev.risks + 1, 14),
        docs: Math.min(prev.docs + 12, 342),
        contradictions: Math.min(prev.contradictions + 1, 7),
        hidden: Math.min(prev.hidden + 1, 23)
      }));
    }, 50);
    return () => clearInterval(interval);
  }, []);
  return <section className="relative bg-navy pt-24 pb-32 overflow-hidden" data-id="element-227" data-mp="q9x9bs7lrxw0">
      {/* Background subtle grid/glow */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#1e293b_1px,transparent_1px),linear-gradient(to_bottom,#1e293b_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)] opacity-20" data-id="element-228" data-mp="2plgkmdgdpi8u" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-229" data-mp="r971sbcfey6m">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-230" data-mp="raqk07hn7jb1">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-2xl" data-id="element-231" data-mp="dapiqqxgu9v1">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight tracking-tight mb-6" data-id="element-232" data-mp="19yn3h1zukwom">
              Entiende una licitación mejor que cualquier competidor.
            </h1>
            <p className="text-lg md:text-xl text-slate-400 mb-8 leading-relaxed" data-id="element-233" data-mp="116bnyb69utnf">
              Prisma analiza cientos de documentos técnicos, contractuales y
              comerciales para identificar riesgos, contradicciones, requisitos
              ocultos y oportunidades antes de presentar una oferta.
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-234" data-mp="23htm4h8j5ss4">
              <Button size="lg" variant="solid" data-id="element-235" data-mp="1ylutuik2zqmf">
                Solicitar Demo
              </Button>
              <Button size="lg" variant="outline" data-id="element-236" data-mp="1tkf78m299c1x">
                Ver Ejemplo
              </Button>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative" data-id="element-237" data-mp="1ooztrv85ti61">
            {/* Mock Product Panel */}
            <div className="bg-slate-900 border border-slate-700 rounded-xl shadow-2xl overflow-hidden flex flex-col" data-id="element-238" data-mp="15xyxjeyfc0q6">
              {/* Panel Header */}
              <div className="bg-slate-800/50 border-b border-slate-700 px-4 py-3 flex items-center justify-between" data-id="element-239" data-mp="wv7il56camts">
                <div className="flex items-center gap-2" data-id="element-240" data-mp="38i19ooy3z2ds">
                  <div className="w-3 h-3 rounded-full bg-risk" data-id="element-241" data-mp="3ck4nvlc5wl2r" />
                  <div className="w-3 h-3 rounded-full bg-amber-500" data-id="element-242" data-mp="3cmhfyrbmwbtj" />
                  <div className="w-3 h-3 rounded-full bg-emerald-500" data-id="element-243" data-mp="3hksql49r6qct" />
                </div>
                <div className="text-xs font-medium text-slate-400 uppercase tracking-wider" data-id="element-244" data-mp="3mhj53n5wtdw4">
                  Análisis de Licitación ID-8492
                </div>
              </div>

              {/* Panel Body */}
              <div className="p-6" data-id="element-245" data-mp="2tug6kv18h35v">
                <div className="grid grid-cols-2 gap-4 mb-6" data-id="element-246" data-mp="2yszxzaylj75m">
                  <div className="bg-slate-800/50 border border-slate-700 rounded-lg p-4" data-id="element-247" data-mp="2yreyd6xfcy0w">
                    <div className="flex items-center gap-2 text-slate-400 mb-2" data-id="element-248" data-mp="33lavk75v6gv0">
                      <ShieldAlert size={16} className="text-risk" data-id="element-249" data-mp="263avsua5h12f" />
                      <span className="text-xs font-medium uppercase" data-id="element-250" data-mp="2b35moxtxdqnh">
                        Riesgos
                      </span>
                    </div>
                    <div className="text-3xl font-bold text-white" data-id="element-251" data-mp="gngn35mibbth">
                      {counters.risks}
                    </div>
                  </div>
                  <div className="bg-slate-800/50 border border-slate-700 rounded-lg p-4" data-id="element-252" data-mp="qd9x42703ivm">
                    <div className="flex items-center gap-2 text-slate-400 mb-2" data-id="element-253" data-mp="llrwxgcsxmbp">
                      <FileText size={16} className="text-techblue" data-id="element-254" data-mp="10b654l4n5xpi" />
                      <span className="text-xs font-medium uppercase" data-id="element-255" data-mp="109d0tchi3pko">
                        Documentos
                      </span>
                    </div>
                    <div className="text-3xl font-bold text-white" data-id="element-256" data-mp="19c49x5mwm995">
                      {counters.docs}
                    </div>
                  </div>
                  <div className="bg-slate-800/50 border border-slate-700 rounded-lg p-4" data-id="element-257" data-mp="14ayjjegpuy2s">
                    <div className="flex items-center gap-2 text-slate-400 mb-2" data-id="element-258" data-mp="3b5bt4q5n1b0b">
                      <AlertTriangle size={16} className="text-amber-500" data-id="element-259" data-mp="365z542315xw5" />
                      <span className="text-xs font-medium uppercase" data-id="element-260" data-mp="1ln56czfcxvjl">
                        Contradicciones
                      </span>
                    </div>
                    <div className="text-3xl font-bold text-white" data-id="element-261" data-mp="1cu1rcmp2damu">
                      {counters.contradictions}
                    </div>
                  </div>
                  <div className="bg-slate-800/50 border border-slate-700 rounded-lg p-4" data-id="element-262" data-mp="1gtalvtrxhcjg">
                    <div className="flex items-center gap-2 text-slate-400 mb-2" data-id="element-263" data-mp="12uaz6rnz77px">
                      <Eye size={16} className="text-cyan" data-id="element-264" data-mp="17vi8ww9oigz8" />
                      <span className="text-xs font-medium uppercase" data-id="element-265" data-mp="tvfrfb5a9pki">
                        Req. Ocultos
                      </span>
                    </div>
                    <div className="text-3xl font-bold text-white" data-id="element-266" data-mp="xyluyb10h2na">
                      {counters.hidden}
                    </div>
                  </div>
                </div>

                <div className="space-y-3" data-id="element-267" data-mp="2sa0luv5rd84m">
                  <div className="text-xs font-medium text-slate-500 uppercase tracking-wider mb-2" data-id="element-268" data-mp="5233wltnsxgm">
                    Hallazgos Críticos
                  </div>

                  <motion.div initial={{
                  opacity: 0,
                  x: 20
                }} animate={{
                  opacity: 1,
                  x: 0
                }} transition={{
                  delay: 0.8
                }} className="flex items-start gap-3 p-3 bg-risk/10 border border-risk/20 rounded-md" data-id="element-269" data-mp="1oylbjg01ma">
                    <div className="w-2 h-2 rounded-full bg-risk mt-1.5 shrink-0" data-id="element-270" data-mp="eyzh34ui67ri" />
                    <div data-id="element-271" data-mp="a1z8ona6ksx8">
                      <p className="text-sm font-medium text-slate-200" data-id="element-272" data-mp="a0o6ut0apv8r">
                        Multa diaria por retraso excede límite legal
                      </p>
                      <p className="text-xs text-slate-400 mt-1" data-id="element-273" data-mp="12plc9vjerxk3">
                        Bases Administrativas Especiales, Pág 42 vs Ley 19.886
                      </p>
                    </div>
                  </motion.div>

                  <motion.div initial={{
                  opacity: 0,
                  x: 20
                }} animate={{
                  opacity: 1,
                  x: 0
                }} transition={{
                  delay: 1.0
                }} className="flex items-start gap-3 p-3 bg-slate-800/50 border border-slate-700 rounded-md" data-id="element-274" data-mp="1f0mfq9aa4k41">
                    <div className="w-2 h-2 rounded-full bg-amber-500 mt-1.5 shrink-0" data-id="element-275" data-mp="22qzzlcipncnj" />
                    <div data-id="element-276" data-mp="27nqehwis427d">
                      <p className="text-sm font-medium text-slate-200" data-id="element-277" data-mp="27o8gl9s4han7">
                        Contradicción en especificación de material
                      </p>
                      <p className="text-xs text-slate-400 mt-1" data-id="element-278" data-mp="2goon6s45wxwa">
                        Plano E-04 indica Acero A36, EETT indica Acero A572
                      </p>
                    </div>
                  </motion.div>
                </div>
              </div>
            </div>

            {/* Decorative Prism Glow */}
            <div className="absolute -inset-4 bg-cyan/20 blur-3xl -z-10 rounded-full opacity-50" data-id="element-279" data-mp="3by2k9qoo5343" />
          </motion.div>
        </div>
      </div>
    </section>;
}